import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
// eslint-disable-next-line import/no-cycle
import { Modal, FormError } from 'common/components/layout';
import { getDefaultCountryCode } from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { addCustomerAddress } from 'redux/customerAddresses/actions';

import AddEditForm from './components/AddEditForm';
import { validateAdd } from './validators';

class AddModal extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const successFunction = (address) => {
      props.onAddAddress(address);
    };
    props.addCustomerAddress(data, successFunction);
  };

  render() {
    const { settings, change, customerAddresses, initialValues } = this.props;
    const { handleSubmit, form } = this.props;
    const { onCloseModal, cancelFunction = onCloseModal } = this.props;
    if (!settings.data) {
      return (
        <Modal title="Add Address" onCloseModal={onCloseModal}>
          &nbsp;
        </Modal>
      );
    }

    if (!initialValues.countryCode) {
      return (
        <Modal
          title="Add Address"
          onCloseModal={onCloseModal}
          formName={form}
        />
      );
    }

    const addressArr = Object.keys(customerAddresses.data);
    const isFirstAddress = addressArr.length === 0 || false;

    return (
      <Modal title="Add Address" onCloseModal={onCloseModal} formName={form}>
        <FormError formName={form} />
        <AddEditForm
          onSubmit={handleSubmit(this.handleSubmit)}
          saveButtonText="Add Address"
          object={initialValues}
          changeFunction={change}
          onCancelFunction={cancelFunction}
          isFirstAddress={isFirstAddress}
          settings={settings}
        />
      </Modal>
    );
  }
}

const transformData = (values) => {
  const data = transformAddressData(values);
  data.isDefault = values.isDefault || false;
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear = values.birthYear && convertStringToInteger(values.birthYear);
  const errors = validateAdd(data, ownProps.settings);
  return errors;
};

const mapStateToProps = (state) => {
  const customer = state.customer.data;

  const address = {};
  if (customer) {
    if (customer.birthDate) {
      address.birthDay = customer.birthDate.substring(8, 10);
      address.birthMonth = customer.birthDate.substring(5, 7);
      address.birthYear = customer.birthDate.substring(0, 4);
    }
    address.firstName = customer.firstName;
    address.lastName = customer.lastName;
    address.city = customer.city;
    address.stateCode = customer.stateCode;
    address.zipCode = customer.zipCode;
    address.countryCode = customer.countryCode;
    address.phone = customer.phones[0] && customer.phones[0].phone;
  }
  if (!address.countryCode && state.setting && state.setting.data) {
    address.countryCode = getDefaultCountryCode(state.setting);
  }
  return {
    initialValues: initialFormValues(address),
    settings: state.setting,
    customerAddresses: state.customerAddress
  };
};

AddModal = reduxForm({
  form: 'AddModal',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(AddModal);

export default connect(mapStateToProps, {
  addCustomerAddress
})(AddModal);
